export default __webpack_public_path__ + "static/media/polgot-screenshot-02.1cb6a309.png";